import React from 'react';
import { useNavigate } from 'react-router-dom';
import { HiOutlineInformationCircle } from 'react-icons/hi';
import './PaymentSuccess.css';

// PHASE 1: Payment processing disabled
// Payments not accepted during Phase 1

const PaymentSuccess = () => {
  const navigate = useNavigate();

  return (
    <div className="payment-result-container">
      <div className="payment-result-card success">
        <div className="success-icon" aria-hidden="true"><HiOutlineInformationCircle /></div>
        <h1>Payment Processing Disabled</h1>
        <p>During Phase 1, all features are completely free!</p>
        <p className="info-text">
          You don't need to purchase credits. Enjoy unlimited messaging and all features at no cost.
        </p>
        <div className="button-group">
          <button 
            onClick={() => navigate('/discover')}
            className="btn-primary"
          >
            Continue to App
          </button>
        </div>
      </div>
    </div>
  );
};

export default PaymentSuccess;
